<template>
  <v-card>
    <v-card-title class="align-center justify-center third white--text mb-4">Historique</v-card-title>
    <v-card-text>
      <v-skeleton-loader v-if="loading" type="table-tbody" />
      <v-data-table
        v-else
        :headers="headers"
        :items="contractValidityHistory"
        :items-per-page="5"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api';
import { format, fromUnixTime } from 'date-fns';
import { fr } from 'date-fns/locale';
import { sendNotification } from '@/helpers/utils';
import { getContractValidityHistory } from '@/helpers/request';

export default {
  props: {
    contract: { type: Object, default: () => ({}) }
  },
  setup (props) {
    const contractValidityHistory = ref([]);
    const loading = ref(false);

    const headers = [
      { text: "Date de modification de la date d'expiration du contrat", value: 'date', width: '30%', align: 'center' },
      { text: "Date d'expiration précédente", value: 'oldDate', width: '20%', align: 'center' },
      { text: "Nouvelle date d'expiration", value: 'newDate', width: '20%', align: 'center' },
      { text: 'Collaborateur', value: 'collaboratorUuid', width: '30%', align: 'center' }
    ];

    const computeHistory = (array) => {
      return array.map(item => ({
        ...item,
        date: format(fromUnixTime(item.timestamp), 'dd/MM/yyyy HH:mm', { locale: fr }),
        oldDate: format(new Date(item.oldEndDate), 'dd/MM/yyyy HH:mm', { locale: fr }),
        newDate: format(new Date(item.newEndDate), 'dd/MM/yyyy HH:mm', { locale: fr })
      })).sort((a, b) => (a.timestamp > b.timestamp ? -1 : 1));
    };

    const loadHistory = async () => {
      if (!props.contract?.contractNumber) return;

      loading.value = true;
      const response = await getContractValidityHistory(props.contract.contractNumber);
      loading.value = false;

      if (response.success && response.data) {
        sendNotification('success', 'Historique des modifications du contrat récupéré avec succès');
        contractValidityHistory.value = computeHistory(response.data);
      } else {
        sendNotification('error', "Erreur lors de la récupération de l'historique des modifications du contrat");
      }
    };

    onMounted(() => loadHistory());

    return { loading, headers, contractValidityHistory, loadHistory };
  }
};
</script>
